import { useEffect, useState } from "react";

import {
  DESKTOP_SLIDES_TO_SHOW,
  getSlidesToShowForWidth,
} from "./useSliderSettings";

function getInitialSlidesToShow() {
  if (typeof window === "undefined") {
    return DESKTOP_SLIDES_TO_SHOW;
  }

  return getSlidesToShowForWidth(window.innerWidth);
}

export function useResponsiveSlidesToShow(
  containerEl: HTMLElement | null,
  slideBaseWidth?: number,
) {
  const [visibleSlides, setVisibleSlides] = useState<number>(
    getInitialSlidesToShow,
  );

  useEffect(() => {
    if (!containerEl) {
      return;
    }

    const updateFromWidth = (width?: number) => {
      setVisibleSlides(getSlidesToShowForWidth(width, slideBaseWidth));
    };

    // Initialize with the current width.
    updateFromWidth(containerEl.clientWidth);

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver((entries) => {
        const width = entries[0]?.contentRect.width;
        updateFromWidth(width);
      });
      observer.observe(containerEl);
      return () => observer.disconnect();
    }

    // Fallback: listen to window resize events.
    const handleResize = () => updateFromWidth(containerEl.clientWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [containerEl, slideBaseWidth]);

  return visibleSlides;
}
